import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/icon.png'


const _hoisted_1 = { id: "login_page" }
const _hoisted_2 = { class: "wraplogin" }
const _hoisted_3 = { class: "main_login" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "img_lg" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "70",
    class: "img_l",
    alt: "logo cong ty"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Bệnh Viện Y học cổ truyền thành phố Đà Nẵng", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", null, "Đăng nhập hệ thống", -1)
const _hoisted_7 = { class: "it_lg" }
const _hoisted_8 = { class: "it_lg" }
const _hoisted_9 = { class: "it_lg it_lgbt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_InputText, {
            id: "firstname",
            type: "text",
            modelValue: $setup.userName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userName) = $event)),
            placeholder: "Tên đăng nhập"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_InputText, {
            id: "lastname",
            type: "password",
            modelValue: $setup.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => ($setup.doLogin()), ["enter"])),
            placeholder: "Mật khẩu"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          ($setup.valid)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "Đăng nhập",
                icon: "pi pi-sign-in",
                iconPos: "left",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.doLogin()))
              }))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                label: "Đăng nhập",
                icon: "pi pi-sign-in",
                iconPos: "left",
                disabled: "disabled"
              }))
        ])
      ])
    ])
  ]))
}